<script>
    import Fa from 'svelte-fa';
    import { faPlus } from '@fortawesome/pro-solid-svg-icons';

    import { formatMoney } from '$lib/utils/functions/money';

    import ProductOptionSelector from '$lib/components/ProductOptionSelector.svelte';

    export let index;
    export let upsell;
    export let selectedUpsells;
    export let upsellActivated = false;

    let selectedVariant = {};
    let productPrice = Number(upsell?.priceRange?.maxVariantPrice?.amount);

    // Push/Replace items in selectedUpsells[]
    const addToUpsellsArray = (status) => {
        const upsellPosition = index + 1;
        const upsellIndexInArray = selectedUpsells.findIndex((item) => item?.position === upsellPosition);

        const upsellObject = {
            position: upsellPosition,
            selected: status,
            merchandiseId: selectedVariant?.id,
            quantity: 1,
            price: productPrice,
            availableForSale: selectedVariant?.availableForSale
        };

        if (upsellIndexInArray !== -1) {
            selectedUpsells[upsellIndexInArray] = upsellObject; // replace existing object
        } else {
            selectedUpsells.push(upsellObject); // push new object
        }
    };

    // Check if upsell is selected and push/replace it in selectedUpsells[]
    $: if (upsellActivated && selectedVariant?.id) {
        addToUpsellsArray(true);
    } else {
        addToUpsellsArray(false);
    }
</script>

{#if upsell?.availableForSale}
    <div class="mb-4 border-t border-base-800 pt-4">
        <div class="flex w-full items-center text-sm">
            <button class="w-full pr-2 text-left" on:click={() => (upsellActivated = !upsellActivated)}>
                <span><Fa icon={faPlus} class="mr-1 inline-block" size="0.8x" /> {upsell?.title}</span>
                <span class="ml-1 text-xs opacity-50">(+ {formatMoney(productPrice)})</span>
            </button>
            <label class="relative inline-flex cursor-pointer items-center" for={upsell?.title ? upsell?.title?.replaceAll(' ', '') : null}>
                <input
                    type="checkbox"
                    name={upsell?.title}
                    id={upsell?.title ? upsell?.title?.replaceAll(' ', '') : null}
                    class="peer sr-only"
                    on:change={() => {
                        upsellActivated = !upsellActivated;
                    }}
                    checked={upsellActivated}
                />
                <div
                    class="
                            peer h-5 w-9 rounded-full bg-base-700
                            after:absolute after:start-[2px] after:top-[2px] after:h-4 after:w-4 after:rounded-full after:bg-color-text/70 after:transition-all after:content-['']
                            peer-checked:bg-primary peer-checked:after:translate-x-full peer-checked:after:bg-white rtl:peer-checked:after:-translate-x-full
                        "
                />
            </label>
        </div>
        <div
            class={`w-full transition-all duration-300 ease-in-out
            ${upsellActivated ? 'opacity-1 no-scrollbar max-h-[100rem] overflow-y-scroll' : 'max-h-0 opacity-0'}`}
        >
            <ProductOptionSelector options={upsell?.options} variants={upsell?.variants} bind:selectedVariant />
        </div>
    </div>
{/if}
